import React from 'react';
import UnderConstruction from '../../../components/UnderConstruction';

const ArticlesAdminPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 to-blue-900">
            <UnderConstruction 
                title="ARTICLES ADMIN CRUD"
                description="</> Sedang dibuat </>"
            />
        </div>
    );
};

export default ArticlesAdminPage;